import React from "react";

class UnAuthorized extends React.Component {

    render() {
        return (

            <div className="text-center">
                <h1>You are not authorized to view this page.</h1>
            </div>

        )
    }
}

export default UnAuthorized;
